module.exports = __webpack_public_path__ + "static/media/04.29e0f577.JPG";